import { DonationType } from "@/constants";
import { DonorListComponent } from "./DonorListComponent";

export function PadethaDonors() {

    return (
        <DonorListComponent
            type={DonationType.BOHI_ETERNAL_TREE}
        />
    )
}
